import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import {
  Box,
  Button,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Modal,
  TextField,
  Typography,
  Pagination
} from "@mui/material";

import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon
} from "@mui/icons-material";

const Tablelist = props => {
  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3001/api/";
  } else {
    xURL = "https://sau.rihes.cmu.ac.th/api/";
  }

  const [dataTable, _dataTable] = useState([]);

  const [page, setPage] = useState(1);
  const rowsPerPage = 5;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginatedData = dataTable.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const [openModal, setOpenModal] = useState(false);
  const [newData, setNewData] = useState({ title: "", file: null });

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editData, setEditData] = useState({
    title: "",
    link: "",
    cmutolink: ""
  });

  useEffect(() => {
    Find_doc(props.taborder);
  }, []);

  const Find_doc = zorder => {
    axios
      .post(xURL + "find_doc_list", { order: zorder })
      .then(result => {
        ShowDoc(result.data);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const ShowDoc = zdata => {
    const Tb1 = [];

    zdata.forEach((i, idx) => {
      Tb1.push({
        id: idx + 1,
        title: i.name,
        link: i.file_link,
        cmutolink: i.cmu_to_link
      });
    });

    _dataTable(Tb1);
  };

  const handleOpenModal = () => {
    setNewData({ title: "", file: null });

    setOpenModal(true);
  };
  
  const handleCloseModal = () => setOpenModal(false);

  const handleFileChange = event => {
    const file = event.target.files[0];

    if (file && file.type !== "application/pdf") {
      Swal.fire({
        title: "ไฟล์ไม่ถูกต้อง",
        text: "กรุณาอัพโหลดเฉพาะไฟล์ PDF",
        icon: "error",
        confirmButtonColor: "#3F51B5"
      });
      return;
    }

    setNewData({ ...newData, file });
  };

  const handleAddData = () => {
    // console.log("ชื่อเรื่อง:", newData.title);
    // console.log("ไฟล์ที่อัพโหลด:", newData.file);

    if (!newData.title) {
      Swal.fire({
        title: "บันทึกไม่ได้",
        text: "ยังไม่ได้กรอก ชื่อเรื่อง",
        icon: "info",
        confirmButtonColor: "#3F51B5",
        willOpen: () => {
          // เพิ่ม z-index ที่สูงกว่า Modal MUI
          const swal = document.querySelector(".swal2-container");
          if (swal) {
            swal.style.zIndex = 1500; // หรือมากกว่า z-index ของ Modal
          }
        }
      });
      return;
    } else if (!newData.file) {
      Swal.fire({
        title: "บันทึกไม่ได้",
        text: "ยังไม่ได้เพิ่มไฟล์",
        icon: "info",
        confirmButtonColor: "#3F51B5",
        willOpen: () => {
          // เพิ่ม z-index ที่สูงกว่า Modal MUI
          const swal = document.querySelector(".swal2-container");
          if (swal) {
            swal.style.zIndex = 1500; // หรือมากกว่า z-index ของ Modal
          }
        }
      });
      return;
    } else {
      insertDoc();
    }
  };

  const insertDoc = () => {
    const fd = new FormData();
    fd.append("file", newData.file);

    let xupload = "";
    if (props.taborder == 1) {
      xupload = "uploadfile";
    } else if (props.taborder == 2) {
      xupload = "uploadfile2";
    } else if (props.taborder == 3) {
      xupload = "uploadfile3";
    } else if (props.taborder == 4) {
      xupload = "uploadfile4";
    } else if (props.taborder == 5) {
      xupload = "uploadfile5";
    }

    axios.post(xURL + "" + xupload, fd).then(res => {
      //   console.log(newData.title, res.data.filename, props.taborder);
      axios
        .post(xURL + "insert_doc", {
          name: newData.title,
          filename: res.data.filename,
          order: props.taborder
        })
        .then(result => {
          Swal.fire({
            title: "บันทึกสำเร็จ!",
            text: "ข้อมูลถูกบันทึกเรียบร้อย",
            icon: "success",
            confirmButtonColor: "#3F51B5",
            willOpen: () => {
              // เพิ่ม z-index ที่สูงกว่า Modal MUI
              const swal = document.querySelector(".swal2-container");
              if (swal) {
                swal.style.zIndex = 1500; // หรือมากกว่า z-index ของ Modal
              }
            }
          }).then(() => {
            Find_doc(props.taborder);

            handleCloseModal();
          });
        })
        .catch(function(error) {
          // handle error
          console.log("problem here", error);
        });
    });
  };

  const handleEdit = (title, link, cmutolink) => {
    setEditData({ title, link, cmutolink });
    setEditModalOpen(true);
  };

  const handleUpdateData = () => {
    if (!editData.title) {
      Swal.fire({
        title: "ไม่สามารถบันทึกได้",
        text: "ชื่อเรื่องว่าง",
        icon: "warning",
        confirmButtonColor: "#3F51B5",
        willOpen: () => {
          // เพิ่ม z-index ที่สูงกว่า Modal MUI
          const swal = document.querySelector(".swal2-container");
          if (swal) {
            swal.style.zIndex = 1500; // หรือมากกว่า z-index ของ Modal
          }
        }
      });
      return;
    }

    // console.log("ชื่อเรื่อง:", editData.title);
    // console.log("cmutolink:", editData.cmutolink);

    axios
      .post(xURL + "update_doc", {
        title: editData.title,
        cmutolink: editData.cmutolink,
        order: props.taborder
      })
      .then(res => {
        Swal.fire({
          title: "อัปเดตสำเร็จ!",
          text: "ข้อมูลถูกแก้ไขแล้ว",
          icon: "success",
          confirmButtonColor: "#3F51B5",
          willOpen: () => {
            // เพิ่ม z-index ที่สูงกว่า Modal MUI
            const swal = document.querySelector(".swal2-container");
            if (swal) {
              swal.style.zIndex = 1500; // หรือมากกว่า z-index ของ Modal
            }
          }
        }).then(() => {
          Find_doc(props.taborder);
          setEditModalOpen(false);
        });
      })
      .catch(error => {
        console.log("update error:", error);
      });
  };

  const handleDelete = (id, title, link) => {
    if (!link) {
      Swal.fire({
        title: "ลบไม่ได้",
        text: "ไม่มีไฟล์นี้ในฐานข้อมูล",
        icon: "info",
        confirmButtonColor: "#3F51B5"
      });
    } else {
      Swal.fire({
        title: "ยืนยัน ลบข้อมูล",
        text: "เรื่อง " + title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(result => {
        if (result.isConfirmed) {
          axios
            .post(xURL + "delete_file", {
              title: title,
              order: props.taborder
            })
            .then(result => {})
            .catch(function(error) {
              // handle error
              console.log("problem here", error);
            });

          axios
            .post(xURL + "delete_doc", {
              title: title,
              linkfile: link
            })
            .then(result => {
              Swal.fire({
                title: "ลบสำเร็จ!",
                text: "ข้อมูลถูกลบเรียบร้อย",
                icon: "success",
                confirmButtonColor: "#3F51B5"
              }).then(() => {
                Find_doc(props.taborder);
              });
            })
            .catch(function(error) {
              // handle error
              console.log("problem here", error);
            });
        }
      });
    }
  };

  return (
    <React.Fragment>
      {/* ปุ่มเพิ่มข้อมูล */}
      <Box sx={{ textAlign: "left" }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleOpenModal}
          sx={{ mb: 1 }}
        >
          เพิ่มข้อมูล
        </Button>
      </Box>

      {/* Modal สำหรับเพิ่มข้อมูล */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "white",
            boxShadow: 24,
            p: 4,
            borderRadius: 2
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            เพิ่มข้อมูลใหม่
          </Typography>

          {/* ฟอร์มกรอกชื่อเรื่อง */}
          <TextField
            fullWidth
            label="ชื่อเรื่อง"
            variant="outlined"
            sx={{ mb: 2 }}
            value={newData.title}
            onChange={e => setNewData({ ...newData, title: e.target.value })}
          />

          {/* อัพโหลดไฟล์ */}
          <Button
            variant="contained"
            component="label"
            fullWidth
            sx={{ mb: 2 }}
          >
            อัพโหลดไฟล์
            <input
              type="file"
              hidden
              accept="application/pdf"
              onChange={handleFileChange}
            />
          </Button>

          {/* แสดงชื่อไฟล์ที่อัพโหลด */}
          {newData.file &&
            <Typography variant="body2" sx={{ mb: 2, color: "gray" }}>
              ไฟล์ที่เลือก: {newData.file.name}
            </Typography>}

          {/* ปุ่มบันทึกข้อมูล */}
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleAddData}
          >
            บันทึกข้อมูล
          </Button>
        </Box>
      </Modal>

      {/* Modal สำหรับแก้ไขข้อมูล */}
      <Modal open={editModalOpen} onClose={() => setEditModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "white",
            boxShadow: 24,
            p: 4,
            borderRadius: 2
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            แก้ไขข้อมูล
          </Typography>

          <TextField
            fullWidth
            label="ชื่อ"
            variant="outlined"
            sx={{ mb: 2 }}
            value={editData.title}
            onChange={e => setEditData({ ...editData, title: e.target.value })}
          />
          <TextField
            fullWidth
            label="Link"
            variant="outlined"
            sx={{ mb: 2 }}
            value={editData.link}
            onChange={e => setEditData({ ...editData, link: e.target.value })}
            slotProps={{
              input: {
                readOnly: true
              }
            }}
          />
          <TextField
            fullWidth
            label="cmuToLink"
            variant="outlined"
            sx={{ mb: 2 }}
            value={editData.cmutolink}
            onChange={e =>
              setEditData({ ...editData, cmutolink: e.target.value })}
          />

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleUpdateData}
          >
            แก้ไข
          </Button>
        </Box>
      </Modal>

      <TableContainer component={Paper} sx={{ mt: 1, borderRadius: 2 }}>
        <Table size="small">
          <TableHead sx={{ backgroundColor: "#3F51B5" }}>
            <TableRow>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                #
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                ชื่อ
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Link
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                cmuToLink
              </TableCell>
              <TableCell
                sx={{ color: "white", fontWeight: "bold", textAlign: "center" }}
              >
                จัดการ
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map(row =>
              <TableRow key={row.id}>
                <TableCell>
                  {row.id}
                </TableCell>
                <TableCell>
                  {row.title}
                </TableCell>
                <TableCell>
                  {row.link
                    ? <Button
                        variant="outlined"
                        size="small"
                        color="primary"
                        href={row.link}
                        target="_blank"
                        rel="noopener"
                      >
                        เปิดลิงก์
                      </Button>
                    : <div />}
                </TableCell>
                <TableCell>
                  {row.cmutolink}
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  <IconButton
                    color="warning"
                    onClick={() =>
                      handleEdit(row.title, row.link, row.cmutolink)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => handleDelete(row.id, row.title, row.link)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Pagination
          count={Math.ceil(dataTable.length / rowsPerPage)}
          page={page}
          onChange={handleChangePage}
          color="primary"
        />
      </Box>
    </React.Fragment>
  );
};

export default Tablelist;
